<template>
    <div class="tickets">
        <div :class="['search-bar', {'tickets-from-hide': getWindowSettings.hideTicketFromFilter}]">
            <filter-to v-if="!getWindowSettings.hideTicketFromFilter"
                       :placeholder="localizeList.departFrom"
                       :items="filtersData.cityFrom"
                       :show-cities="false"
                       @blur="filterBlur('from')"
                       @change="changeFrom()"
                       v-model="filtersModel.from"
                       class="search-bar-item"/>
            <filter-to :placeholder="localizeList.departTo"
                       :items="filtersData.countryTo"
                       :second-items="filtersData.cityTo"
                       :disabled="!filtersModel.from.length"
                       :focus-from-parent="focusFilterTo"
                       @blur="filterBlur('to')"
                       @click="validation('departureTo')"
                       @get-cities="getCitiesToWithCash($event)"
                       v-model="filtersModel.to"
                       class="search-bar-item"></filter-to>

            <tickets-calendar :placeholder="localizeList.whenUpper"
                              :disabled="disabledCalendar()"
                              :direct="direct"
                              :active-dates="filtersData.activeDates"
                              :focus-from-parent="focusFilterDate"
                              @blur="filterBlur('date')"
                              @getActiveDate="getActiveDate($event)"
                              @click="validation('calendar')"
                              @press-tab="focusPeopleCounter()"
                              v-model="filtersModel.date"
                              class="search-bar-item"/>

            <people-counter :items="peopleCount"
                            :show="filtersData.peopleShow"
                            @hide="filtersData.peopleShow = false"
                            class="search-bar-item"
                            v-model="filtersModel.people"/>
            <base-button @click.native="search(true)" 
                         background="var(--orange-color)" 
                         padding="4px 24px" 
                         :searchLoaderStatus="searchLoaderStatus">
                <svg v-if="!searchLoaderStatus" width="24px" height="24px" fill="var(--white-color)">
                    <use xlink:href="../../assets/images/sprite.svg#search"></use>
                </svg>
                <base-loader v-else size="22" weight="5"/>
            </base-button>
        </div>

        <!--Компонента для показа валидации филтров-->
        <validation-popup :text="validationText" v-model="validationShow"/>
    </div>
</template>

<script>

    import * as methods from '@/plugins/methods.js';
    import ticketsCalendar from "./ticketsCalendar";
    import peopleCounter from "../tour/mainFilters/peopleCounter";
    import validationPopup from "../baseComponents/validationPopup";
    import filterTo from "./filterTo";

    import Vue from "vue";
    import {bus} from "../../main";
    import moment from "moment"

    export default {
        name: "search",
        components: {
            filterTo,
            ticketsCalendar,
            peopleCounter,
            validationPopup,
        },
        data() {
            return {
                API_URL: this.$store.getters['getApiUrl'],
                API_ORIGIN: this.$store.getters['getApiOrigin'],
                filtersModel: {
                    from: [],
                    to: [],
                    date: {},
                    people: {
                        adult: {},
                        children: []
                    },
                },
                filtersData: {
                    cityFrom: {
                        title: "Все варианты",
                        items: []
                    },
                    countryTo: {
                        title: "Все варианты",
                        items: []
                    },
                    cityTo: [],
                    activeDates: [],
                    firstActiveDates: [],
                    peopleShow: false,
                },
                peopleCount: [
                    {
                        name: "adults",
                        count: 2
                    },
                    {
                        name: "childs",
                        count: 0
                    }
                ],
                validationText: "",
                validationShow: false,
                direct: null,
                searchLoaderStatus: false,
                isReady: false,
                focusFilterTo: false,
                focusFilterDate: false,
                getActiveDateApi: null,
                settings: null,
            }
        },
        computed: {
            getWindowSettings() {
                return window.settings;
            },
            getSettings() {
                const settings = {
                    TourSearchMode: 0
                };
                // return settings
                return this.$store.getters['getSettings'] || settings
            },
            getAviaQuota() {
                return this.$store.getters['tickets/getAviaQuota']
            },
            isDateValid() {
                if (this.direct === 'twoway') {
                    return this.filtersModel.date?.dates[1]?.length
                } else {
                    return this.filtersModel.date?.dates[0]?.length
                }
            },
            checkFiltersBeforeSearch() {
                const from = this.filtersModel.from.length > 0;
                const to = this.filtersModel.to.length === 2;
                const date = this.isDateValid;
                let invalidAge = this.filtersModel.people.children.some(child => child.age === null)

                return from && to && date && !invalidAge;
            }
        },
        created() {
            bus.$on("ticketsSearchNormal", () => {
              if (this.checkFiltersBeforeSearch) {
                this.search()
              }
            });
            bus.$on("ticketsSearch", (cb) => {
                this.search()
                    .then(() => {
                        setTimeout(() => cb(), 100)
                    });
            });
            bus.$on('tickets-slide-date-from', data => {
                let date = this.filtersModel.date.dates[data.index];
                let newDate = "";

                if (data.to === "left") {
                    newDate = moment(date).add(-7, "days").format("DD.MM.YYYY");
                } else {
                    newDate = moment(date).add(7, "days").format("DD.MM.YYYY");
                }

                let isValid = false;
                if (data.index === 0) {
                    let dateFrom = new Date(newDate.split(".").reverse().join("/"));
                    let dateTo = new Date(this.filtersModel.date.dates[1]);
                    if (this.direct !== "oneway" && dateFrom < dateTo && this.filtersData.firstActiveDates.includes(newDate)) {
                        isValid = true;
                    } else if (this.direct === "oneway" && this.filtersData.firstActiveDates.includes(newDate)) {
                        isValid = true;
                    }
                } else {
                    let dateTo = new Date(newDate.split(".").reverse().join("/"));
                    let dateFrom = new Date(this.filtersModel.date.dates[0]);
                    if (dateFrom < dateTo && this.filtersData.activeDates.includes(newDate)) {
                        isValid = true;
                    }
                }
                if (isValid) {
                    this.filtersModel.date.dates = this.filtersModel.date.dates.map((x, i) => {
                        if (i === data.index) {
                            return newDate.split(".").reverse().join("/");
                        } else {
                            return x;
                        }
                    });
                    let href = this.$route.fullPath;
                    let newUrl = href;
                    let dateForUrl = newDate.split(".").reverse().join("");
                    if (data.index === 0) {
                        newUrl = href.replace(/departureDate=\d+&/, `departureDate=${dateForUrl}&`);
                    } else {
                        newUrl = href.replace(/returnDate=\d+&/, `returnDate=${dateForUrl}&`);
                    }
                    if (this.$route.fullPath !== newUrl) {
                        this.$router.push(newUrl)
                        this.search(true)
                            .then(() => {
                                data.cb()
                            })
                    }
                } else {
                    data.cb()
                }
            });
            bus.$on('change-direct', val => {
                if (val === 1) {
                    this.direct = "twoway"
                } else {
                    this.direct = "oneway"
                }
                const isTicket = this.$route.fullPath.includes("Individuals/Avia");
                if (isTicket)
                    this.mountedFilters();
            });
            bus.$on('mounted-ticket', () => {
                const isTicket = this.$route.fullPath.includes("Individuals/Avia");
                if (isTicket)
                    this.mountedFilters();
            });
            bus.$on("change-search-type", (type) => {
                if (type === "tickets") this.mountedFilters(true);
            });

            let urlParams = this.$route.params.searchParams;
            if (urlParams) bus.$emit("main-search-status", false);
        },
        mounted() {
            this.settings = this.$store.getters['getSettings'];

        },
        methods: {
            mountedFilters(changeSsearchType = false) {
                if (!this.isReady)
                    this.setFiltersOfUrl();

                this.isReady = true;

                let cashPeople = JSON.parse(methods.getCookieValueByName("ticketsPeople"));
                if (cashPeople) {
                    this.filtersModel.people = cashPeople;
                    this.peopleCount = [
                        cashPeople.adult,
                        {
                            name: "childs",
                            count: cashPeople.children.length
                        }
                    ]
                }

                this.filtersModel.date.dates = [];
                this.filtersModel.date.days = null;
                this.getCities()
                    .then(() => {
                        const settingsCashFrom = window.settings.ticketsDepartureCity;
                        let cashFrom = typeof settingsCashFrom === "number"
                            ? [settingsCashFrom] : JSON.parse(methods.getCookieValueByName("ticketsFrom"));

                        const cashFromIncludes = this.filtersData.cityFrom.items.map(x => x.id).includes(cashFrom[0]);
                        if (!cashFromIncludes) {
                            this.filtersModel.from = [];
                            this.filtersModel.to = [];
                        }
                        if (cashFrom && cashFromIncludes) {

                            this.filtersModel.from = [cashFrom[0]];
                            this.getCountryTo().then(() => {
                                let cashDate = methods.getCookieValueByName("ticketsDate");
                                cashDate = JSON.parse(cashDate);
                                if (
                                    cashDate && this.filtersModel.to.length === 2 &&
                                    (cashDate.dates[0] && this.direct === "oneway" || this.direct === "twoway" && cashDate.dates[1])
                                ) {
                                    let date = this.direct === "oneway" || cashDate.dates[1] ? null : cashDate.dates[0];
                                    this.getActiveDate(date).then(() => {
                                        if (this.direct === "oneway") {
                                            cashDate.dates = cashDate.dates.filter((x, i) => i === 0)
                                        }
                                        this.filtersModel.date = {...cashDate};
                                        let hasParams = this.$route.fullPath.includes("Individuals/Avia")
                                            && this.$route.fullPath.includes("currency");

                                        if (hasParams && !changeSsearchType)
                                            this.search();
                                    })
                                }
                            })
                        }
                    })
                    .catch(() => {
                        // console.log(111);
                    })
            },
            focusPeopleCounter() {
                this.filtersData.peopleShow = true
            },
            getCities() {
                return new Promise((resolve, reject) => {
                    let date = new Date().getTime();
                    Vue.Api.Get(this.API_URL + `individuals/avia/${this.direct}/departures?_=` + date)
                        .then(res => {
                            if (!res.data.length) {
                                reject()
                            }
                            this.filtersData.cityFrom.items = [];
                            let data = res.data;
                            data.forEach(val => {
                                this.filtersData.cityFrom.items.push({
                                    text: val.Name,
                                    id: val.Key,
                                    isChecked: false
                                })
                            });
                            resolve(true)
                        });
                })
            },
            showValidation(text) {
                this.validationShow = true;
                this.validationText = text;
            },
            validation(type) {
                let text = "";
                let res = false;

                switch (type) {
                    case "departureTo":
                        if (!this.filtersModel.from.length) {
                            text = `${this.localizeList.firstSetField} ${this.localizeList.fromUpper}`
                            this.showValidation(text);
                            break;
                        }
                        res = true;
                        break;
                    case "calendar":
                        if (!this.filtersModel.from.length) {
                            text = `${this.localizeList.firstSetField} ${this.localizeList.fromUpper}`
                            this.showValidation(text)
                            break;
                        }
                        if (this.filtersModel.to.length < 1) {
                            text = `${this.localizeList.firstSetField} ${this.localizeList.departTo}`;
                            this.showValidation(text);
                            break
                        }
                        if (this.filtersModel.to.length < 2) {
                            text = `${this.localizeList.firstSetField} ${this.localizeList.cityUpper}`;
                            this.showValidation(text);
                            break
                        }
                        res = true;
                        break;
                    case "search":
                        if (!this.filtersModel.from.length) {
                            text = `${this.localizeList.firstSetField} ${this.localizeList.fromUpper}`
                            this.showValidation(text)
                            break;
                        }
                        if (this.filtersModel.to.length < 1) {
                            text = `${this.localizeList.firstSetField} ${this.localizeList.departTo}`;
                            this.showValidation(text);
                            break
                        }
                        if (this.filtersModel.to.length < 2) {
                            text = `${this.localizeList.firstSetField} ${this.localizeList.cityUpper}`;
                            this.showValidation(text);
                            break
                        }
                        if (!this.isDateValid) {
                            text = `${this.localizeList.firstSetField} ${this.localizeList.whenUpper}`;
                            this.showValidation(text);
                            break;
                        }
                        res = true;
                        break;
                }
                return res
            },
            getCountryTo() {
                return new Promise(resolve => {
                    let date = new Date().getTime();
                    let city = this.filtersModel.from[0];
                    // let countryToIds = this.filtersData.countryTo.items.map(x => x.id);

                    Vue.Api.Get(this.API_URL + `individuals/avia/${this.direct}/arrivals/${city}/countries?_=` + date)
                        .then(res => {
                            let data = res.data;
                            let isCash = false;
                            let cashTo = JSON.parse(methods.getCookieValueByName("ticketsTo"));

                            let settingsCashTo = window.settings.ticketsDestination;
                            if (typeof settingsCashTo === "number")
                                cashTo = [settingsCashTo];
                            this.filtersData.countryTo.items = [];
                            // data.filter(x => !countryToIds.includes(x.Key)).forEach((val) => {
                            data.forEach((val) => {
                                this.filtersData.countryTo.items.push({
                                    text: val.Name,
                                    id: val.Key,
                                    isChecked: false
                                });
                                if (cashTo && cashTo[0] == val.Key) {
                                    isCash = true
                                }
                            });
                            if (!isCash) {
                                this.filtersModel.to = [];
                                resolve()
                            } else {
                                if (!this.filtersModel.to.length) {
                                    this.getCitiesTo(cashTo[0])
                                        .then(() => {
                                            this.filtersModel.to = cashTo;
                                            resolve()
                                        })
                                } else {
                                    resolve()
                                }
                            }
                        });
                })
            },
            getCitiesToWithCash(e) {
                this.getCitiesTo(e)
                    .then((res) => {
                        const citiesKeys = res.data.map(x => x.Key)
                        let settingsDestCities = window.settings.ticketsDestCities?.filter(x => {
                            if (citiesKeys.includes(x)) return x;
                        });
                        if (settingsDestCities?.length) {
                            this.filtersModel.to = [ e, ...settingsDestCities ]
                        }
                    })
            },
            getCitiesTo(countryId) {
                return new Promise((resolve) => {
                    let date = new Date().getTime();
                    let city = this.filtersModel.from[0];
                    Vue.Api.Get(this.API_URL + `individuals/avia/${this.direct}/arrivals/${city}/${countryId}?_=` + date)
                        .then(res => {
                            res.data.forEach(x => {
                                if (x.Key === -1) {
                                    return
                                }
                                this.filtersData.cityTo = [];
                                this.filtersData.cityTo.push({
                                    text: x.Name,
                                    id: x.Key,
                                    isChecked: false
                                })
                            })
                            resolve(res)
                        });
                });
            },
            getActiveDate(selectedDate = null) {
                return new Promise((resolve) => {
                    let date = new Date().getTime();
                    let cityFrom = this.filtersModel.from[0];
                    let cityTo = this.filtersModel.to[1];
                    let api = "";

                    if (!cityTo) {
                        return
                    }

                    cityTo = this.filtersModel.to[1];
                    api = this.API_URL + `individuals/avia/${this.direct}/departures/dates/${cityFrom}/${cityTo}?_=` + date;

                    if (selectedDate) {
                        selectedDate = selectedDate.split("/").join("");
                        api = this.API_URL + `individuals/avia/${this.direct}/arrivals/dates/${cityFrom}/${cityTo}/${selectedDate}?_=` + date
                    }

                    if (`${cityFrom}/${cityTo}/${selectedDate}` === this.getActiveDateApi) {
                        resolve();
                        return
                    }
                    this.getActiveDateApi = `${cityFrom}/${cityTo}/${selectedDate}`;

                    Vue.Api.Get(api)
                        .then(res => {
                            this.filtersData.activeDates = [];
                            res.data.forEach(x => {
                                this.filtersData.activeDates.push(x);
                            });
                            if (selectedDate === null) {
                                this.filtersData.firstActiveDates = [...this.filtersData.activeDates];
                            }
                            resolve(true)
                        });
                });
            },
            search(clientClick = false) {
                if (this.searchLoaderStatus) {
                    return
                }

                this.validation("search")
                let isValid = this.validation("search");
                if (!isValid) {
                    return
                }
                let invalidAge = this.filtersModel.people.children.find(x => x.age === null)
                if (invalidAge) {
                    let text = this.localizeList.setChildAge
                    this.showValidation(text);
                    return
                }
                bus.$emit("main-search-status", false);

                this.searchLoaderStatus = true;

                let params = {
                    cityFrom: this.filtersModel.from[0],
                    countryTo: this.filtersModel.to[0],
                    cityTo: this.filtersModel.to[1],
                    date: this.filtersModel.date,
                    people: this.filtersModel.people
                }

                return new Promise(resolve => {
                    this.$store.dispatch("tickets/A_TICKETS_SEARCH", params)
                        .then(res => {
                            let params = this.$route.fullPath;
                            let newUrl = "/Individuals/Avia" + res.replace("?", "/");
                            let moreParams = params.split(/currency=/)[1]?.split("&")?.slice(1)?.join("&");
                            if (moreParams?.length) {
                                newUrl += "&" + moreParams;
                            }
                            if (params !== newUrl) {
                                let hasParams = this.$route.fullPath.includes("Individuals/Avia")
                                if (hasParams) {
                                    this.$router.push(newUrl);
                                    this.$nextTick(() => bus.$emit("main-search-status", true))
                                } else {
                                    bus.$emit("change-cash-url-of", newUrl)
                                    this.$nextTick(() => bus.$emit("main-search-status", true))
                                }
                            } else {
                                this.$nextTick(() => bus.$emit("main-search-status", true))
                            }

                            if (clientClick) {
                                bus.$emit("tickets-searched-client");
                            }
                            bus.$emit("tickets-searched");
                            this.searchLoaderStatus = false;
                            resolve()
                        })
                })
            },
            disabledCalendar() {
                return this.filtersModel.to.length < 2
            },
            setFiltersOfUrl() {
                let params = this.$route.fullPath.split("Individuals/Avia/")[1];
                if (!params)
                    return;

                document.cookie = "ticketsFrom=none; max-age=0";
                document.cookie = "ticketsTo=none; max-age=0";
                document.cookie = "ticketsDate=none; max-age=0";
                document.cookie = "ticketsPeople=none; max-age=0";

                let isOneway = !params.includes("returnDate");
                if (isOneway) {
                    this.direct = "oneway";
                    bus.$emit("change-direct-url", 0)
                }
                params = params.split("&");

                let filterTo = [];
                let date = {
                    dates: [],
                    days: null
                };
                let people = {
                    adult: {
                        name: "adults",
                        count: 2
                    },
                    children: []
                };

                params.forEach(x => {
                    if (x.includes("departureCity")) {
                        let item = +x.split("=")[1];
                        document.cookie = `ticketsFrom=${JSON.stringify([item])}; path=/`;
                    }
                    if (x.includes("destinationCountry") || x.includes("destinationCity")) {
                        let item = +x.split("=")[1];
                        filterTo.push(item);
                    }
                    if (x.includes("departureDate") || x.includes("returnDate")) {
                        let item = x.split("=")[1];
                        item = this.correctDate(item);
                        const currentDate = moment().format('YYYY/MM/DD');
                        if (item >= currentDate)
                            date.dates.push(item);
                    }
                    if (x.includes("flexible")) {
                        let item = +x.split("=")[1];
                        date.days = item;
                    }
                    if (x.includes("adultCount")) {
                        let item = +x.split("=")[1];
                        people.adult.count = item
                    }
                    if (x.includes("childAges")) {
                        let item = x.split("=")[1];
                        item = item.split(",");
                        item.forEach(x2 => {
                            let child = {
                                name: "ageOfChild",
                                css: {"marginLeft": "20px"},
                                age: +x2
                            }
                            people.children.push(child)
                        })
                    }
                });

                document.cookie = `ticketsTo=${JSON.stringify(filterTo)}; path=/`;
                document.cookie = `ticketsDate=${JSON.stringify(date)}; path=/`;
                document.cookie = `ticketsPeople=${JSON.stringify(people)}; path=/`;

            },
            filterBlur(elem) {
                this.$nextTick(() => {
                    if (elem === 'from') {
                        if (this.filtersModel.from.length && !this.filtersModel.to.length) {
                            this.focusFilterTo = true
                        }
                    }
                    if (elem === 'to') {
                        this.focusFilterTo = false;
                        if (this.filtersModel.to.length && !this.filtersModel.date.dates.length && !this.disabledCalendar()) {
                            this.focusFilterDate = true
                        }
                    }
                    if (elem === 'date') {
                        this.focusFilterDate = false;
                    }
                })
            },
            changeFrom() {
                this.$nextTick(() => {
                    let val = this.filtersModel.from;
                    if (val.length) {
                        this.getCountryTo()
                    }
                })
            },
            correctDate(date) {
                let res = "";

                date.split("").forEach((x, i) => {
                    if (i === 4 || i === 6) {
                        res += "/"
                    }
                    res += x
                });
                return res
            }
        },
        watch: {
            "filtersModel.from": {
                deep: true,
                handler(val) {
                    const item = JSON.stringify(val);
                    document.cookie = `ticketsFrom=${item}; path=/`;
                    this.filtersModel.to = []
                }
            },
            "filtersModel.to": {
                deep: true,
                handler(val, old) {
                    if (methods.checkEquality(val, old))
                        return;

                    if (!val.length) {
                        this.filtersModel.date.dates = [];
                    }
                    if (val.length === 2) {
                        const item = JSON.stringify(val);
                        document.cookie = `ticketsTo=${item}; path=/`;
                    }
                    if (val.length === 1) {
                        const item = JSON.stringify(val);
                        document.cookie = `ticketsTo=${item}; path=/`;
                    }

                    let cashDate = methods.getCookieValueByName("ticketsDate");
                    cashDate = JSON.parse(cashDate);

                    const selectedDate = this.filtersModel.date.dates[1] ? null : this.filtersModel.date.dates[0];
                    if (val.length === 2) {
                        if (selectedDate && this.direct !== "oneway") {
                            this.getActiveDate(selectedDate)
                        } else {
                            this.getActiveDate().then(() => {
                                if (cashDate) {
                                    if (this.direct === "oneway") {
                                        cashDate.dates = cashDate.dates.filter((x, i) => i === 0)
                                    }
                                    this.filtersModel.date = {...cashDate};
                                }
                            })
                        }
                    }
                }
            },
            "filtersModel.date": {
                deep: true,
                handler(val) {
                    if (!val.dates.length) return;
                    document.cookie = `ticketsDate=${JSON.stringify(val)}; path=/`;
                }
            },
            "filtersModel.people": {
                deep: true,
                handler(val) {
                    document.cookie = `ticketsPeople=${JSON.stringify(val)}; path=/`;
                }
            }
        }
    }
</script>

<style scoped>
    .tour-navbar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 60px 0;
        background-color: var(--primary-color);
    }

    .tour-navbar .tour-type-controler {
        display: flex;
    }

    .tour-navbar .tour-type-controler .tour-type {
        width: 140px;
        height: 40px;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(255, 255, 255, .3);
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        color: var(--white-color);
        cursor: pointer;
    }

    .tour-navbar .tour-type-controler .tour-type:not(:last-child) {
        margin-right: 4px;
    }

    .tour-navbar .tour-type-controler .tour-type.active {
        background-color: var(--white-color);
        color: var(--dark-2-color);
    }

    .tour-navbar .project-controler {
        display: flex;
        align-items: center;
    }

    .tour-navbar .project-controler .project-controler-item {
        padding: 5px 16px;
        position: relative;
        font-weight: 500;
        font-size: 13px;
        line-height: 15px;
        text-decoration: none;
        color: var(--white-color);
    }

    .tour-navbar .project-controler .project-controler-item:not(:last-child):after {
        content: "";
        width: 1px;
        height: 60%;
        background-color: var(--white-color);
        position: absolute;
        top: 20%;
        right: 0;
    }

    .tour-navbar .login-form {
        padding: 40px 50px 48px;
        overflow: hidden;
        transition: all .2s;
    }

    .tour-navbar .login-form.warning {
        padding: 40px 50px 76px;
    }

    .tour-navbar .login-form .headline {
        margin: 0;
        font-weight: 500;
        font-size: 28px;
        line-height: 33px;
        color: #1D1D1D;
        margin-bottom: 30px;
    }

    .tour-navbar .login-form .input-wrap {
        position: relative;
        margin: 28px 0 40px;
    }

    .tour-navbar .login-form .require-star {
        position: absolute;
        top: 5px;
        right: 0;
        color: red;
    }

    .tour-navbar .login-form .capcha-wrap {
        position: relative;
    }

    .tour-navbar .login-form .capcha-wrap + .input-wrap {
        margin-top: 0;
    }

    .tour-navbar .login-form .input-wrap .forgot-password {
        position: absolute;
        bottom: 8px;
        right: 0;
        font-size: 12px;
        line-height: 14px;
        color: var(--lighten-5-color);
        cursor: pointer;
        text-decoration: none;
    }

    .tour-navbar .login-form .login-warning-block {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        line-height: 15px;
        color: #DA0000;
        background-color: rgba(218, 0, 0, 0.1);
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 14px;
    }

    .tour-navbar .login-form .registration-btn-group {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--primary-color);
    }

    .tour-navbar .login-form .registration-btn-group a {
        text-decoration: none;
        color: var(--primary-color);
    }

    .tour-navbar .login-form .login-btn {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
    }

    .registration-enter-active, .registration-leave-active {
        transition: opacity .5s;
    }

    .registration-enter, .registration-leave-to {
        opacity: 0;
    }

    .search-bar {
        padding: 10px 60px;
        background-color: var(--white-color);
        display: grid;
        grid-template-columns: repeat(4, 1fr) auto;
        grid-gap: 4px;
        /*min-width: 1014px;*/
    }

    .tickets-from-hide {
        grid-template-columns: repeat(3, 1fr) auto;
    }

    @media (max-width: 1200px) {

        .search-bar {
            padding: 10px 40px;
        }

        .tour-navbar {
            padding: 8px 40px 0;
        }
    }
</style>
